module.exports = __webpack_public_path__ + "img/qr_not_active2.30cdc327.svg";